import React, { useEffect, useState, useRef } from "react";
import { ViewComponentProps, withView } from '../shared/viewcomponent';
import GlobalizedText from '../shared/globalization';
import { FeatureFlags } from '../shared/featureFlags';
import './css/paymentapplied.css'
import { ajax, trim, removeLeftZero, validate } from '../shared/utils';
import { useTable } from '../shared/components';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { INVALID_MESSAGES } from '../shared/yupschema';

export const PaymentAppliedComponent = withView((props: ViewComponentProps) => {
    //Get value from previous pages
    const varFormPromp = useRef<any>();
    let companyCodePre: string = trim(props.getQueryParam("companyCode"));
    let groupNumberPre: string = trim(props.getQueryParam("groupNumber"));
    let accountNumberPre: string = trim(props.getQueryParam("accountNumber"));
    let participantIDNumberPre: string = trim(props.getQueryParam("participantIDNumber"));
    let modalDateFromPre: string = trim(props.getQueryParam("modalDateFrom"));
    let modalDateThroughPre: string = trim(props.getQueryParam("modalDateThrough"));
    let invoiceNumberPre: string = trim(props.getQueryParam("invoiceNumber"));
    let agentNumberPre: string = trim(props.getQueryParam("agentNumber"));
    let agentIndicatorPre: string = trim(props.getQueryParam("agentIndicator"));
    let showFlag: boolean = (participantIDNumberPre !== "" && participantIDNumberPre !== undefined && participantIDNumberPre !== null) ? true : false;
    let col: any[] = [];

    //Current page
    const [config, setConfig] = useState<any | null>(null);
    const [tblcol, settblcol] = useState<any[]>([]);
    const showResponsibilityAmountDeductionDate = props.isFeatureEnabled(FeatureFlags.PA_RESPONSIBILITYAMOUNT_DEDUCTIONDATE);
    const renderCheckbox = (data: any, type: any, row: any, meta: any) => {
        let noChargeProductIndicator = trim(row.noChargeProductIndicator);
        if (noChargeProductIndicator === "M") {
            return '<input type="checkbox"  checked onclick="return false;"/>'
        } else {
            return '<input type="checkbox" onclick="return false;"/>'
        }
    }
    useEffect(() => {
        if (config === null) {
            ajax({
                url: '/api/paymentapplied/view',
                params: {
                    companyCode: companyCodePre,
                    groupNumber: groupNumberPre,
                    accountNumber: parseInt(accountNumberPre),
                    participantIDNumber: participantIDNumberPre,
                    agentNumber: agentNumberPre,
                    agentIndicator: agentIndicatorPre,
                    modalDateFrom: modalDateFromPre,
                    modalDateThrough: modalDateThroughPre,
                    invoiceNumber: invoiceNumberPre
                },
                method: 'get',
                success: (res: any) => {
                    props.clearMessage();
                    setConfig(res);


                    if (res.accountType === 'W' && showFlag) {
                        col.push.apply(col, [{ className: "gwp-dt-detail-control", sortable: false },
                        { title: "billpay.modaldate", name: "modalDate" },
                        { title: "common.lbl.name", name: "fullName" },
                        { title: "billpay.paymentApplied.typeOfCharge", name: "typeOfCharge" },
                        { title: "billpay.paymentApplied.appliedDate", name: "appliedDate" },
                        { title: "common.lbl.product", name: "productName" },
                        {
                            title: "billpay.paymentApplied.appliedAmount",
                            name: "appliedAmount", type: "numeric"
                        }]);


                        if (showResponsibilityAmountDeductionDate) {

                            col.push.apply(col, [{
                                title: "common.lbl.memberResponsible",
                                name: "noChargeProductIndicator",
                                render: renderCheckbox,
                            },
                            { title: "common.lbl.deductionDate", name: "deductionDate" }]);
                        }
                    }
                    else if (res.accountType === 'W' && !showFlag) {
                        col.push.apply(col, [{ className: "gwp-dt-detail-control", sortable: false },
                        { title: "billpay.modaldate", name: "modalDate" },
                        { title: "common.lbl.memberIdentifier", name: "participantIDNumber" },
                        { title: "common.lbl.name", name: "fullName" },
                        { title: "billpay.paymentApplied.typeOfCharge", name: "typeOfCharge" },
                        { title: "billpay.paymentApplied.appliedDate", name: "appliedDate" },
                        { title: "common.lbl.product", name: "productName" },
                        { title: "billpay.paymentApplied.appliedAmount", name: "appliedAmount", type: "numeric" },]);

                        if (showResponsibilityAmountDeductionDate) {
                            col.push.apply(col, [{
                                title: "common.lbl.memberResponsible",
                                name: "noChargeProductIndicator",
                                render: renderCheckbox
                            },
                            { title: "common.lbl.deductionDate", name: "deductionDate" }]);
                        }
                    }
                    else if (res.accountType !== 'W' && showFlag) {
                        col.push.apply(col, [{ className: "gwp-dt-detail-control", sortable: false },
                        { title: "billpay.modaldate", name: "modalDate" },
                        { title: "common.lbl.name", name: "fullName" },
                        { title: "billpay.paymentApplied.typeOfCharge", name: "typeOfCharge" },
                        { title: "billpay.paymentApplied.appliedDate", name: "appliedDate" },
                        { title: "common.lbl.product", name: "productName" },
                        { title: "billpay.paymentApplied.appliedAmount", name: "appliedAmount", type: "numeric" },

                        ]);
                        if (showResponsibilityAmountDeductionDate) {
                            col.push.apply(col, [{
                                title: "common.lbl.memberResponsible",
                                name: "noChargeProductIndicator",
                                render: renderCheckbox
                            }]);
                        }
                    }
                    else if (res.accountType !== 'W' && !showFlag) {

                        col.push.apply(col, [{ className: "gwp-dt-detail-control", sortable: false },
                        { title: "billpay.modaldate", name: "modalDate" },
                        { title: "common.lbl.memberIdentifier", name: "participantIDNumber" },
                        { title: "common.lbl.name", name: "fullName" },
                        { title: "billpay.paymentApplied.typeOfCharge", name: "typeOfCharge" },
                        { title: "billpay.paymentApplied.appliedDate", name: "appliedDate" },
                        { title: "common.lbl.product", name: "productName" },
                        { title: "billpay.paymentApplied.appliedAmount", name: "appliedAmount", type: "numeric" },
                        ]);
                        if (showResponsibilityAmountDeductionDate) {
                            col.push.apply(col, [{
                                title: "common.lbl.memberResponsible",
                                name: "noChargeProductIndicator",
                                render: renderCheckbox
                            }]);
                        }
                    }
                    settblcol(col);

                }
            });
        }
    }, []);
    if (config === null) {
        return <></>
    }

    let validationschema = yup.object().shape({
        memberId: yup.string()
            .test('notBothAtTheSameTime',
                INVALID_MESSAGES.LASTNAME_OR_MEMBERID_BOTH_ENTERED,
                function (memberId) {
                    const { lastName } = this.parent;
                    if (lastName && memberId) {
                        return false; // when user enters both userEmail & userName do not validate form
                    }
                    return true;
                })
            .when(['lastName'], {
                is: lastName => !lastName,
                then: yup.string().required(INVALID_MESSAGES.LASTNAME_OR_MEMBERID_IS_REQUIRED)
            }),
        lastName: yup.string()
            .test('notBothAtTheSameTime',
                INVALID_MESSAGES.LASTNAME_OR_MEMBERID_BOTH_ENTERED,
                function (lastName) {
                    const { memberId } = this.parent;
                    if (memberId && lastName) {
                        return false;
                    }
                    return true;
                })
            .when(['memberId'], {
                is: memberId => !memberId,
                then: yup.string().required(INVALID_MESSAGES.LASTNAME_OR_MEMBERID_IS_REQUIRED),
            })
    }, [['memberId', 'lastName']]);
    const formValidate = (values: any): any => {

        return validate(validationschema, values, props);


    }
    const formSubmit = (values: any): void => {
        let req = {
            companyCode: companyCodePre,
            groupNumber: groupNumberPre,
            accountNumber: parseInt(accountNumberPre),
            agentNumber: agentNumberPre,
            agentIndicator: agentIndicatorPre,
            modalDateFrom: modalDateFromPre,
            modalDateThrough: modalDateThroughPre,
            invoiceNumber: invoiceNumberPre,
            lastName: values.lastName,
            participantIDNumber: values.memberId

        };
        ajax({
            url: '/api/paymentapplied/view',
            params: req,
            method: 'get',
            success: (res: any) => {
                props.clearMessage();
                setConfig(res);
            }
        });

    }

    const showall = (formProps: any) => {
        ajax({
            url: '/api/paymentapplied/view',
            params: {
                companyCode: companyCodePre,
                groupNumber: groupNumberPre,
                accountNumber: parseInt(accountNumberPre),
                participantIDNumber: participantIDNumberPre,
                agentNumber: agentNumberPre,
                agentIndicator: agentIndicatorPre,
                modalDateFrom: modalDateFromPre,
                modalDateThrough: modalDateThroughPre,
                invoiceNumber: invoiceNumberPre
            },
            method: 'get',
            success: (res: any) => {
                props.clearMessage();
                setConfig(res);
            }
        });
        props.resetForm(formProps);

    }
    const tableObj = useTable({
        id: "myAppNBTable",
        option: { paging: true, scrollCollapse: true },
        table: {
            columns: tblcol,
            data: config.paymentAppliedDtoList
        },
        isDataLoaded: true
    });


    return <>
        <props.Row>
            <props.Col xs="8" md="8" sm="8">
                <props.PageHeader className="gwp-billingsummary-label" label={() => {
                    return <><GlobalizedText message="billpay.modaldate.from" />
                        <br /> {modalDateFromPre}
                    </>
                }} />
            </props.Col>
            <props.Col xs="4" md="4" sm="4">
                <props.Div className="gwp-float-right" style={{ marginRight: -15 + "px" }}>
                    {/* <props.Icon type="print" size="sm"></props.Icon> */}
                    <props.Span className="gwp-icon gwp-icon-print gwp-icon-sm" style={{ marginRight: -5 + "px" }}></props.Span>
                    <props.Button className="printButton" printVisible={false} onClick={() => props.print({ size: 'A5', orientation: 'landscape' })}><GlobalizedText message="common.print" /></props.Button>
                </props.Div>
            </props.Col>
        </props.Row>
        {(config.currency.currencyName !== undefined && config.currency.countryCode !== undefined) &&
            <props.Row>
                <props.Col sm="12" md="12" xs="12">
                    <GlobalizedText message="common.lbl.allcurrencyvalue"></GlobalizedText> {config.currency.currencyName} ({config.currency.countryCode})
                </props.Col>
            </props.Row>
        }
        <br />
        <props.Panel className="">
            <props.PanelBody>
                <props.Row>
                    <props.Col sm="6" md="6" xs="12">
                        <props.Row>
                            <props.Col sm="6" md="6" xs="12">
                                <props.DL>
                                    <props.DLI title="common.lbl.group" desc={removeLeftZero(config.groupName)}></props.DLI>
                                    <props.DLI title="common.lbl.account" desc={config.accountName}></props.DLI>
                                    {(config.participantIDNumber !== null && config.participantIDNumber !== '') ?
                                        <props.DLI title="common.lbl.member" desc={config.memberName}></props.DLI> :
                                        <props.DLI title="billpay.billfrequency" desc={config.billingFrequency}></props.DLI>
                                    }
                                </props.DL>
                            </props.Col>
                            <props.Col sm="6" md="6" xs="12">
                                <props.DL>
                                    <props.DLI title="billpay.invoicenum" desc={config.invoiceNumber}></props.DLI>
                                </props.DL>
                            </props.Col>
                        </props.Row>
                    </props.Col>
                    <>{!showFlag && <props.Col sm="6" md="6" xs="12" className="panel-container-right payment-applied-bottom">
                        <React.Fragment>
                            <Formik initialValues={{
                                lastName: '',
                                memberId: '',
                            }}
                                validate={formValidate}
                                validateOnBlur={false}
                                validateOnChange={false}
                                onSubmit={formSubmit}
                            >
                                {formProps => {
                                    varFormPromp.current = formProps;
                                    return <Form id="searchByNameOrId" data-print-visible="false">
                                        <props.Panel>
                                            <props.PanelHeading>
                                                <props.Div style={{ fontSize: "12px", fontWeight: 400 }}><GlobalizedText message="billpay_enter" /></props.Div>
                                                <props.Div style={{ fontSize: "12px" }}><GlobalizedText message="common.lbl.jumpTo" /></props.Div>
                                            </props.PanelHeading>
                                            <props.PanelBody>
                                                <props.Row>
                                                    <props.Div>
                                                        <props.Col sm="12" md="5" >
                                                            <props.TextControl name="memberId" id="memberId" label="common.lbl.memberID" />
                                                        </props.Col >
                                                        <props.Col sm="12" md="2" style={{ paddingTop: "10px", marginRight: "5px", width: "20px" }}>
                                                            <br /><GlobalizedText message="common.lbl.or"></GlobalizedText>
                                                        </props.Col >
                                                        <props.Col sm="12" md="5" >
                                                            <props.TextControl name="lastName" id="lastName" label="common.lbl.lastName" />
                                                        </props.Col>
                                                    </props.Div></props.Row>
                                                <props.Row>
                                                    <props.Col sm="12" md="5" >
                                                        <props.Button type="submit" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                            <GlobalizedText message="common.lbl.retrieve" />
                                                        </props.Button>
                                                    </props.Col >
                                                </props.Row>
                                                <props.Row>
                                                    <props.Col sm="12" md="5" className="showAll">
                                                        <props.LinkButton onClick={() => showall(formProps)}><GlobalizedText message="common.lbl.showall" /></props.LinkButton>
                                                    </props.Col >
                                                </props.Row>
                                            </props.PanelBody>
                                        </props.Panel>
                                    </Form>
                                }
                                }
                            </Formik >
                        </React.Fragment >
                    </props.Col>}</>
                </props.Row>
            </props.PanelBody>
        </props.Panel>
        <props.Row condition={config.agentIndicator === 'P'}>
            <props.Col sm="12" md="12" xs="12">
                <props.Div className="information gwp-information">
                    <props.Span className="glyphicon glyphicon-info-sign"></props.Span>
                    <GlobalizedText message="common.msg.bsm.mem.pro.info.not.dsp" />
                </props.Div>
            </props.Col>
        </props.Row>
        <props.Panel>
            <props.PanelBody>
                <props.Row>
                    <props.Col sm="12" md="11">
                        <props.Div className="gwp-sectitle"><GlobalizedText message="common.lbl.payments" />
                        </props.Div>
                    </props.Col>
                </props.Row>
                {config !== null ? <><props.Row>
                    <props.Col md="12" sm="12" xs="12">
                        <tableObj.Component />

                    </props.Col>
                </props.Row></> : ""}
            </props.PanelBody>
        </props.Panel>
    </>
});

